var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-danger btn-back page-action",attrs:{"href":"javascript:;","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Kembali\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }